var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "expressPrintArea" } },
    _vm._l(_vm.printData, function (item, index) {
      return _c(
        "div",
        { key: index, style: { marginTop: index != 0 ? "-10px" : "0" } },
        [
          _c("div", { style: { height: index != 0 ? "130mm" : "120mm" } }, [
            index != 0
              ? _c("div", { staticStyle: { height: "10mm" } })
              : _vm._e(),
            _c("div", {
              staticStyle: {
                height: "1px",
                width: "76mm",
                "border-bottom": "1px solid black",
              },
            }),
            _c(
              "div",
              {
                staticStyle: { height: "40px", width: "100%", display: "flex" },
              },
              [
                _c("div", {
                  staticStyle: {
                    width: "16mm",
                    "border-right": "1px solid black",
                  },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "30mm",
                      "border-right": "1px solid black",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "background-color": "black",
                          color: "white",
                        },
                      },
                      [
                        _vm._v(
                          "代收：￥" + _vm._s(Number(item.codValue).toFixed(2))
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-family":
                            "'Arial Negreta', 'Arial Normal', 'Arial'",
                          "font-weight": "700",
                          "font-style": "normal",
                          "font-size": "16px",
                          "line-height": "20px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(" 月结")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "30mm",
                      overflow: "hidden",
                      display: "flex",
                      "align-items": "center",
                      "flex-wrap": "wrap",
                    },
                  },
                  [_vm._v(" " + _vm._s(item.transType) + " ")]
                ),
              ]
            ),
            _c("div", {
              staticStyle: {
                height: "1px",
                width: "76mm",
                "border-bottom": "1px solid black",
              },
            }),
            _c(
              "div",
              {
                staticStyle: {
                  height: "30px",
                  "text-align": "center",
                  "font-weight": "bold",
                  "line-height": "30px",
                },
              },
              [_vm._v(" " + _vm._s(item.transNo) + " ")]
            ),
            _c("div", {
              staticStyle: {
                height: "1px",
                width: "76mm",
                "border-bottom": "1px solid black",
              },
            }),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  height: "60px",
                  display: "flex",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      float: "left",
                      "margin-left": "10mm",
                      "font-family": "'Arial Negreta', 'Arial Normal', 'Arial'",
                      "font-weight": "700",
                      "font-style": "normal",
                      "font-size": "16px",
                      "line-height": "20px",
                      "margin-top": "10px",
                    },
                  },
                  [_vm._v(" [送] ")]
                ),
                _c(
                  "div",
                  { staticStyle: { float: "right", "margin-right": "35mm" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-family":
                            "'Arial Negreta', 'Arial Normal', 'Arial'",
                          "font-weight": "700",
                          "font-style": "normal",
                          "font-size": "16px",
                          "line-height": "20px",
                        },
                      },
                      [_vm._v(" " + _vm._s(item.receiveOrgName) + " ")]
                    ),
                  ]
                ),
              ]
            ),
            _c("div", {
              staticStyle: {
                height: "1px",
                width: "76mm",
                "border-bottom": "1px solid black",
              },
            }),
            _c(
              "div",
              {
                staticStyle: {
                  width: "76mm",
                  height: "30px",
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "50mm",
                      "text-align": "center",
                      float: "left",
                      "font-family": "'Arial Negreta', 'Arial Normal', 'Arial'",
                      "font-weight": "700",
                      "font-style": "normal",
                      "font-size": "16px",
                      "line-height": "30px",
                    },
                  },
                  [_vm._v(" 纸 ")]
                ),
                _c("div", {
                  staticStyle: {
                    width: "1px",
                    height: "30px",
                    "background-color": "black",
                  },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      float: "right",
                      "font-family": "'Arial Negreta', 'Arial Normal', 'Arial'",
                      "font-weight": "700",
                      "font-style": "normal",
                      "font-size": "16px",
                      "line-height": "30px",
                      "margin-right": "40px",
                    },
                  },
                  [_vm._v(" " + _vm._s(item.order) + " ")]
                ),
              ]
            ),
            _c("div", {
              staticStyle: {
                height: "1px",
                width: "76mm",
                "border-bottom": "1px solid black",
              },
            }),
            item.isM == "是" && item.order.substr(0, 1) != "1"
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-left": "10px",
                    },
                  },
                  [
                    _vm._v(" 母"),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(_vm._s(item.m)),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-left": "10px",
                      height: "20px",
                    },
                  },
                  [_c("span", { staticStyle: { "margin-left": "10px" } })]
                ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "font-family": "'Arial Negreta', 'Arial Normal', 'Arial'",
                  "font-weight": "700",
                  "font-style": "normal",
                  "font-size": "12px",
                  "line-height": "16px",
                  "border-bottom": "1px solid black",
                  "margin-top": "50px",
                },
              },
              [
                item.isM == "是" && item.order.substr(0, 1) != "1"
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "-4px",
                          "margin-left": "10px",
                        },
                      },
                      [_vm._v("子 ")]
                    )
                  : item.isM == "是" && item.order.substr(0, 1) == "1"
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "-4px",
                          "margin-left": "10px",
                        },
                      },
                      [_vm._v("母")]
                    )
                  : _c("div"),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "-4px",
                      "margin-right": "8px",
                    },
                  },
                  [_vm._v("已验视")]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  height: "60px",
                  display: "flex",
                  "justify-content": "start",
                },
              },
              [
                _vm._m(0, true),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-right": "20px",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          "line-height": "12px",
                        },
                      },
                      [_vm._v(_vm._s(item.conName || "cdd"))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          "line-height": "12px",
                        },
                      },
                      [_vm._v(_vm._s(item.conPhone || "15011111111"))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          "line-height": "12px",
                        },
                      },
                      [_vm._v(_vm._s(item.caddress || "上海市浦东新区"))]
                    ),
                  ]
                ),
              ]
            ),
            _c("div", {
              staticStyle: {
                height: "1px",
                width: "76mm",
                "border-bottom": "1px solid black",
              },
            }),
            _c("div", { staticStyle: { height: "70px" } }, [
              _c("div", [_vm._v("签收单：无需返单")]),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-right": "20px",
                    display: "flex",
                    "flex-wrap": "wrap",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "30%",
                        "font-size": "10px",
                        "line-height": "12px",
                      },
                    },
                    [_vm._v("寄 " + _vm._s(item.shipperName))]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "30%",
                        "font-size": "10px",
                        "line-height": "12px",
                        "margin-right": "20px",
                      },
                    },
                    [_vm._v(_vm._s(item.shipperPhone) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "40%",
                        "font-size": "10px",
                        "line-height": "12px",
                        "margin-right": "20px",
                      },
                    },
                    [_vm._v(_vm._s(item.saddress) + " ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "12px",
                    "line-height": "14px",
                    "margin-top": "10px",
                  },
                },
                [
                  _c("div", [_vm._v("品名：" + _vm._s(item.cargoName))]),
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v("备注：" + _vm._s(item.transNote)),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticStyle: { "margin-top": "50px" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    float: "left",
                    "font-size": "10px",
                    "line-height": "12px",
                  },
                },
                [
                  _vm._v("打印时间： "),
                  _c("span", { staticStyle: { "margin-right": "10px" } }, [
                    _vm._v(_vm._s(_vm.printTime)),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "right",
                    "font-size": "10px",
                    "line-height": "12px",
                    "margin-right": "10px",
                  },
                },
                [_vm._v("第" + _vm._s(index + 1) + "单")]
              ),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticStyle: {
          width: "35px",
          height: "40px",
          "margin-top": "10px",
          "margin-left": "20px",
        },
        attrs: { src: "https://vip.deppon.com/vas-cas-web/img/recipient.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }